import Logger from './Logger'

const logger = Logger.getInstance()

const BV_PRODUCT_OPTIONS = {
  reviews: 'RatingsAndReviews',
  questions: 'AskAndAnswer'
}

const getInViewData = (props, bvProduct) => {
  const { attributes, partNumber } = props
  return {
    bvProduct,
    productId: partNumber,
    brand: attributes.brand
  }
}

const getViewExtraData = (bvProduct, isViewed) => {
  const containerId = bvProduct === BV_PRODUCT_OPTIONS.reviews ? 'reviews' : 'qanda'
  let data = {
    minPixels: 50,
    containerId
  }
  if (isViewed) {
    data = {
      ...data,
      minTime: 5000
    }
  }
  return data
}

const getPageViewData = (props, bvProduct) => {
  const { breadcrumb, stats } = props
  let pageViewdData = {
    ...getInViewData(props, bvProduct),
    type: 'Product',
    categoryId: breadcrumb[breadcrumb.length - 1]?.id,
    rootCategoryId: breadcrumb[0]?.id
  }
  if (bvProduct === BV_PRODUCT_OPTIONS.reviews) {
    const { overallRating = 0, reviewCount = 0 } = stats.attributes
    pageViewdData = {
      ...pageViewdData,
      numReviews: reviewCount,
      avgRating: overallRating
    }
  } else if (bvProduct === BV_PRODUCT_OPTIONS.questions) {
    const { questionCount = 0, answerCount = 0 } = stats.attributes
    pageViewdData = {
      ...pageViewdData,
      numQuestions: questionCount,
      numAnswers: answerCount
    }
  }

  return pageViewdData
}

const fireImpressionPerContent = (array, baseImpressionData, contentType) => {
  const BV = window.BV.pixel
  array.forEach(content => {
    BV.trackImpression({ ...baseImpressionData, contentId: content.id, contentType })
    if (contentType === 'question' && content.attributes?.answers?.length) {
      fireImpressionPerContent(content.attributes.answers, baseImpressionData, 'answer')
    }
  })
}

const trackImpresion = (props, bvProduct) => {
  const { breadcrumb } = props
  const baseImpressionData = {
    ...getInViewData(props, bvProduct),
    categoryId: breadcrumb[breadcrumb.length - 1]?.id
  }
  if (bvProduct === BV_PRODUCT_OPTIONS.reviews && props.allFetchedReviews?.length) {
    fireImpressionPerContent(props.allFetchedReviews, baseImpressionData, 'review')
  } else if (bvProduct === BV_PRODUCT_OPTIONS.questions && props.questions?.length) {
    fireImpressionPerContent(props.questions, baseImpressionData, 'question')
  }
}

const getBVFeatureData = (props, bvProduct) => {
  const { breadcrumb } = props
  return {
    ...getInViewData(props, bvProduct),
    type: 'Used',
    categoryId: breadcrumb[breadcrumb.length - 1]?.id
  }
}

const runBVTrack = (type, props, bvProduct, name, detail1, detail2) => {
  try {
    const BV = window.BV.pixel
    switch (type) {
      case 'Passive':
        BV.trackPageView(getPageViewData(props, bvProduct))
        BV.trackInView(getInViewData(props, bvProduct), getViewExtraData(bvProduct))
        BV.trackViewedCGC(getInViewData(props, bvProduct), getViewExtraData(bvProduct, true))
        trackImpresion(props, bvProduct)
        break
      case 'FeaturedEvent':
        BV.trackEvent('Feature', {
          ...getBVFeatureData(props, bvProduct),
          name,
          detail1,
          detail2
        })
        break
      default:
        break
    }
  } catch (error) {
    logger.error(
      'bazaarVoiceLogger',
      {
        bvProduct,
        name,
        detail1,
        detail2,
        error
      },
      'BazzarVoice tracking error'
    )
  }
}

const isBV = () => !!window.BV && !!window.BV.pixel

const isQuestions = attributes => {
  const { questionCount = 0, answerCount = 0 } = attributes
  return questionCount + answerCount > 0
}

const runBVReviewsTrack = (type, props, name, detail1, detail2) => {
  const delayTime = isBV() ? 0 : 1000
  setTimeout(() => {
    if (isBV() && (name === 'link' || props.reviews.length)) {
      runBVTrack(type, props, BV_PRODUCT_OPTIONS.reviews, name, detail1, detail2)
    } else if (!isBV() && type === 'Passive') {
      // Function called by Tealium when BV is loaded
      window.BVReviewsTrack = () => {
        if (props.reviews.length) {
          runBVTrack(type, props, BV_PRODUCT_OPTIONS.reviews)
        }
      }
    }
  }, delayTime)
}

const runBVQuestionsTrack = (type, props, name, detail1, detail2) => {
  const delayTime = isBV() ? 0 : 1000
  setTimeout(() => {
    if (isBV() && props.stats.attributes && isQuestions(props.stats.attributes)) {
      runBVTrack(type, props, BV_PRODUCT_OPTIONS.questions, name, detail1, detail2)
    } else if (!isBV() && type === 'Passive') {
      // Function called by Tealium when BV is loaded
      window.BVQuestionsTrack = () => {
        if (props.stats.attributes && isQuestions(props.stats.attributes)) {
          runBVTrack(type, props, BV_PRODUCT_OPTIONS.questions)
        }
      }
    }
  }, delayTime)
}

export {
  getInViewData,
  getViewExtraData,
  getPageViewData,
  getBVFeatureData,
  isQuestions,
  runBVReviewsTrack,
  runBVQuestionsTrack
}
